import {
  AUTH_STORAGE_KEY,
  REFRESH_TOKEN_STORAGE_KEY,
} from "config/envConfig";
import swtAlert from "lib/sweetAlert";

function clearStoredTokens() {
  try {
    window.localStorage?.removeItem(AUTH_STORAGE_KEY);
    window.localStorage?.removeItem(REFRESH_TOKEN_STORAGE_KEY);
  } catch {
    // ignore
  }
}

let sessionExpiryHandling = false;

/**
 * Shows a SweetAlert, clears auth (Redux + tokens), and sends the user to login.
 * Used when an authenticated API call returns 401.
 */
export async function handleUnauthorizedSession() {
  if (sessionExpiryHandling) return;
  sessionExpiryHandling = true;
  try {
    await swtAlert.warning(
      "Session expired",
      "Your session has expired. Please sign in again.",
    );
  } catch {
    // dismissed or closed — still log out
  }
  try {
    const [{ store }, { LogoutUser }] = await Promise.all([
      import("store/storeIndex"),
      import("store/reducer"),
    ]);
    store.dispatch(LogoutUser());
  } catch {
    // Avoid importing `lib/api` here (circular). LogoutUser clears tokens when store works.
    clearStoredTokens();
  } finally {
    sessionExpiryHandling = false;
  }
  if (typeof window !== "undefined") {
    window.location.replace(`${window.location.origin}/login`);
  }
}
